module.exports = __webpack_public_path__ + "static/media/espiral.1da40931.svg";